import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { Brand } from "../../../models/brand";

export function brandTypeValidator(brands: Brand[]): ValidatorFn {
  return (control: AbstractControl<string[]>): ValidationErrors | null => {
    const selectedBrands: Brand[] = brands.filter(brand => control.value.includes(brand.name));
    const types: string[] = [...new Set(selectedBrands.map(x => x.groupType))];
    return types.length > 1 ? { differentBrandTypeError: 'differentBrandTypeError'} : null;
  }
}
